"use client";

import type { ReactNode } from "react";
import { GameIconButton } from "../game-ui";
import { useGame } from "../GameProvider";

interface ActivityHeaderProps {
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
}

export function ActivityHeader({ title, children, actions }: ActivityHeaderProps) {
  const { goTo } = useGame();

  return (
    <header className="space-y-2">
      <div className="flex items-center gap-2">
        <GameIconButton
          icon="back"
          tone="slate"
          size="sm"
          onClick={() => goTo("activities")}
        />
        <h1 className="min-w-0 flex-1 truncate text-base font-extrabold text-white sm:text-lg">
          {title}
        </h1>
        {actions}
      </div>
      {children}
    </header>
  );
}
